import { State } from '@/components/atoms';
import { ProductCard, TabsContent } from '@/components/molecules';
import { useProducts, useDeleteProduct, useUpdateProduct } from '@/api';
import { filterProducts } from '@/lib/helpers/filter-products';

interface AllProductsProps {
  onAddProduct: () => void;
  searchQuery: string;
  categoryId?: number;
  subcategoryId?: number;
  onView: (id: number) => void;
  onEdit: (id: number) => void;
}

export const AllProducts = ({
  onAddProduct,
  searchQuery,
  categoryId,
  subcategoryId,
  onView,
  onEdit,
}: AllProductsProps) => {
  const { data: products } = useProducts({ categoryId, subcategoryId });
  const { mutate: remove } = useDeleteProduct();
  const { mutate: update } = useUpdateProduct();

  const filteredProducts = filterProducts(products, {
    searchQuery,
    categoryId,
    subcategoryId,
  });

  const hasActiveFilters =
    !!searchQuery.trim() || categoryId != null || subcategoryId != null;

  return (
    <TabsContent value="all">
      {filteredProducts && filteredProducts.length < 1 ? (
        <State
          description={
            hasActiveFilters
              ? 'No products match your filters'
              : 'No products found'
          }
          button={
            hasActiveFilters
              ? undefined
              : {
                  icon: 'Plus',
                  text: 'Add Product',
                  onClick: onAddProduct,
                }
          }
        />
      ) : (
        <div className="grid grid-cols-12 gap-2.5">
          {filteredProducts?.map((product, index) => (
            <ProductCard
              key={product?.id || index}
              id={product?.id}
              name={product?.name}
              description={product?.shortDescription}
              price={product?.price}
              categoryName={product?.category?.name}
              subcategoryName={product?.subcategory?.name}
              handleOOS={() => update({ quantity: 0, id: product?.id })}
              handleBIS={() => update({ quantity: 1, id: product?.id })}
              quantity={product?.quantity}
              images={product?.productImages?.map((img) => img?.image?.url)}
              handleDelete={() => remove(product?.id)}
              handleView={() => onView(product.id)}
              handleEdit={() => onEdit(product.id)}
              className="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
              variant="owner"
            />
          ))}
        </div>
      )}
    </TabsContent>
  );
};
